<script setup lang="ts">
import { computed } from 'vue'
import type { ReportParameter, ReportScalar } from '@/modules/reportTemplates/api'

const props = defineProps<{ field: ReportParameter; modelValue: ReportScalar; disabled?: boolean; error?: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: ReportScalar] }>()
const value = computed({ get: () => props.modelValue, set: nextValue => emit('update:modelValue', nextValue) })
const label = computed(() => props.field.label + (props.field.required ? ' *' : ''))
</script>

<template>
  <VCheckbox
    v-if="field.type === 'boolean'"
    v-model="value"
    :label="label"
    :disabled="disabled"
    :error-messages="error"
    :hint="field.hint"
    persistent-hint
    hide-details="auto"
  />
  <VTextarea
    v-else-if="field.type === 'text'"
    v-model="value"
    :label="label"
    :hint="field.hint"
    persistent-hint
    rows="3"
    auto-grow
    :maxlength="field.max_length"
    :disabled="disabled"
    :error-messages="error"
  />
  <VAutocomplete
    v-else-if="['employee', 'select'].includes(field.type)"
    v-model="value"
    :label="label"
    :items="field.choices"
    item-title="label"
    item-value="value"
    :hint="field.hint"
    persistent-hint
    clearable
    :disabled="disabled"
    :error-messages="error"
    no-data-text="Нет доступных вариантов"
  />
  <VTextField
    v-else
    v-model="value"
    :label="label"
    :type="field.type === 'date' ? 'date' : ['integer', 'number'].includes(field.type) ? 'number' : 'text'"
    :step="field.type === 'integer' ? 1 : 'any'"
    :min="field.minimum ?? undefined"
    :max="field.maximum ?? undefined"
    :maxlength="field.max_length"
    :hint="field.hint"
    persistent-hint
    :disabled="disabled"
    :error-messages="error"
  />
</template>
